import { bindActionCreators } from 'redux';
import { EntityFiltersActions, ConfigActions, FuzzyActions, ServerListActions } from 'actions';

const mapDispatchToProps = (dispatch, ownProps) => {
    const name = ownProps.entity ? ownProps.entity.entity : '';
    const setConfigWeb = bindActionCreators(ConfigActions, dispatch).setConfigWeb;

    return {
        initFilters: bindActionCreators(EntityFiltersActions, dispatch).initFilters,
        toggleFilters: bindActionCreators(EntityFiltersActions, dispatch).toggleFilters,
        changeFilter: bindActionCreators(EntityFiltersActions, dispatch).changeFilter,
        changeAdvancedFilter: bindActionCreators(EntityFiltersActions, dispatch)
            .changeAdvancedFilter,
        deleteMultipleFilters: bindActionCreators(EntityFiltersActions, dispatch)
            .deleteMultipleFilters,
        clearFilters: bindActionCreators(EntityFiltersActions, dispatch).clearFilters,
        saveCache: (config, partial) => setConfigWeb(`${name}_filters`, config, partial),
        setConfigWeb,
        getFuzzy: bindActionCreators(FuzzyActions, dispatch).getFuzzy,
        getList: bindActionCreators(ServerListActions, dispatch).getList,
        removeView: bindActionCreators(EntityFiltersActions, dispatch).removeView,
        createView: bindActionCreators(EntityFiltersActions, dispatch).createView,
        setFilterDragging: bindActionCreators(EntityFiltersActions, dispatch).setFilterDragging,
        disableForceCrossFilters: bindActionCreators(EntityFiltersActions, dispatch)
            .disableForceCrossFilters,
    };
};

export default mapDispatchToProps;
